var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFitnessStudio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7802 128.599C19.9283 138.824 51.0431 146.852 65.7382 127.708C81.6329 135.311 107.85 132.954 129.194 121.051C132.163 119.397 134.971 117.307 136.691 114.375C140.573 107.757 140.665 98.5744 133.582 85.0255C121.774 55.5478 100.535 29.6724 91.9607 19.2667C90.2 17.6614 78.9685 15.3815 72.119 13.1909C69.0936 12.2534 63.4601 11.632 56.7222 20.5112C53.5279 24.7207 39.0171 35.0593 57.4287 42.0118C60.2811 42.7376 62.3778 44.076 75.3908 41.6988C77.0856 41.4048 81.3169 41.6988 84.2986 46.9325L90.5262 55.8385C91.1057 56.6675 91.4819 57.6214 91.5972 58.6264C92.6884 68.1193 92.6529 80.0045 97.9457 86.023C89.7706 80.1115 68.407 73.0904 52.3102 93.0689M12.6787 81.9532C20.3306 74.6762 42.5092 63.1807 65.9801 79.3034",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7802 128.599C19.9283 138.824 51.0431 146.852 65.7382 127.708C81.6329 135.311 107.85 132.954 129.194 121.051C132.163 119.397 134.971 117.307 136.691 114.375C140.573 107.757 140.665 98.5744 133.582 85.0255C121.774 55.5478 100.535 29.6724 91.9607 19.2667C90.2 17.6614 78.9685 15.3815 72.119 13.1909C69.0936 12.2534 63.4601 11.632 56.7222 20.5112C53.5279 24.7207 39.0171 35.0593 57.4287 42.0118C60.2811 42.7376 62.3778 44.076 75.3908 41.6988C77.0856 41.4048 81.3169 41.6988 84.2986 46.9325L90.5262 55.8385C91.1057 56.6675 91.4819 57.6214 91.5972 58.6264C92.6884 68.1193 92.6529 80.0045 97.9457 86.023C89.7706 80.1115 68.407 73.0904 52.3102 93.0689M12.6787 81.9532C20.3306 74.6762 42.5092 63.1807 65.9801 79.3034",
    stroke: "url(#paint0_linear_16725_950)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16725_950",
    x1: 12.6787,
    y1: 12.679,
    x2: 163.188,
    y2: 55.5442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitnessStudio);
export default __webpack_public_path__ + "static/media/Fitness-studio.4d930ce8a56523f30ec584e22b061c23.svg";
export { ForwardRef as ReactComponent };